import { MeetingViewModel } from '@components';
import { IMeeting, useViewModel } from '@utils';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

interface IDayProps {
  meeting: IMeeting;
}

export const Meeting: FC<IDayProps> = observer(({ meeting }) => {

  const meetingViewModel = useViewModel(MeetingViewModel);
  const onClickMeeting = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    meetingViewModel.setPopupCoordinates({
      top: e.pageY,
      left: e.pageX,
      showTop: e.clientY > window.innerHeight / 2,
      showLeft: e.clientX > window.innerWidth / 2,
    });
    meetingViewModel.setMoreMeetingInformation(meeting);
  };

  return (
    <div
      className="meeting fade-in"
      style={{ background: meeting.calendarColor }}
      onClick={onClickMeeting}
    >
      {meeting.meetingName}
    </div>
  );
});

